import { useContext } from 'react';
import { Link } from 'react-router-dom';
import Header from '@edx/frontend-component-header';
import { AppContext } from '@edx/frontend-platform/react';
import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';

import { ROUTES } from '@src/routes';
import { baseAppUrl, catalogAppUrl } from '@src/utils';
import { useMenuItems } from './hooks/useMenuItems';
import messages from './messages';

type CatalogAppContext = {
  authenticatedUser: {
    username?: string;
  } | null;
};

const getPublicSiteLabel = (siteName?: string) => {
  const trimmedSiteName = siteName?.trim();

  if (!trimmedSiteName) {
    return 'WutiSkill';
  }

  return trimmedSiteName.replace(/\s+Dev$/i, '') || 'WutiSkill';
};

const WutiskillMark = () => (
  <span className="catalog-public-header__mark" aria-hidden="true">
    W
  </span>
);

const PublicCatalogHeader = () => {
  const config = getConfig();
  const intl = useIntl();
  const siteLabel = getPublicSiteLabel(config.SITE_NAME);

  return (
    <header className="catalog-public-header">
      <div className="catalog-public-header__inner">
        <Link className="catalog-public-header__brand" to={ROUTES.HOME}>
          <WutiskillMark />
          <span className="catalog-public-header__brand-label">{siteLabel}</span>
        </Link>

        <div className="catalog-public-header__actions">
          <a className="catalog-ui-button catalog-ui-button--secondary" href={config.LOGIN_URL || baseAppUrl('/login')}>
            {intl.formatMessage(messages.signIn)}
          </a>
          <a className="catalog-ui-button catalog-ui-button--primary" href={config.REGISTER_URL || baseAppUrl('/register')}>
            {intl.formatMessage(messages.getStarted)}
          </a>
        </div>
      </div>
    </header>
  );
};

const CatalogHeader = () => {
  const { authenticatedUser } = useContext(AppContext) as CatalogAppContext;
  const { mainMenu, secondaryMenu } = useMenuItems();

  if (!authenticatedUser) {
    return <PublicCatalogHeader />;
  }

  return (
    <Header
      mainMenuItems={mainMenu}
      secondaryMenuItems={secondaryMenu}
      logoDestination={catalogAppUrl(ROUTES.HOME)}
    />
  );
};

export default CatalogHeader;
